module.exports = __webpack_public_path__ + "img/3D.df2d014b.webp";